// extracted by mini-css-extract-plugin
export default {"ttl":"styles_ttl__Gbjqq","txt":"styles_txt__uP3Ff","btn":"styles_btn__q2RSu","errorMsg":"styles_errorMsg__6VfpW","signin":"styles_signin__Nr3i5"};